var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isReady
    ? _c(
        "div",
        { staticClass: "content animate-panel", attrs: { id: "home" } },
        [
          _c("top-banner", { attrs: { images: _vm.topBanner } }),
          _vm._v(" "),
          _c("div", { staticClass: "mr-t-20 text-gray" }, [
            _c("div", { staticClass: "row font-bold" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm.amountsData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "card-content text-right" },
                          [
                            _c("div", {}, [
                              _c("span", { staticClass: "text-size-32" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(_vm.amountsData[0].value)
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.amountsData[0].unit) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.amountsData[0].rate >= 0
                              ? _c("div", { staticClass: "text-green" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-up",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.abs(_vm.amountsData[0].rate)
                                      ) +
                                      "%\n            "
                                  )
                                ])
                              : _c("div", { staticClass: "text-orange" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-down",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.abs(_vm.amountsData[0].rate)
                                      ) +
                                      "%\n            "
                                  )
                                ]),
                            _vm._v(" "),
                            _c("table-sales-growth", {
                              attrs: {
                                columns: _vm.amountColumns,
                                data: _vm.amountsData.slice(1)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mr-t-10" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      _vm.handleClickViewAnalysis()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                さらに表示する\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-circle-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm.ordersData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "card-content text-right" },
                          [
                            _c("div", {}, [
                              _c("span", { staticClass: "text-size-28" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(_vm.ordersData[0].value)
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.ordersData[0].unit) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.ordersData[0].rate >= 0
                              ? _c("div", { staticClass: "text-green" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-up",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(Math.abs(_vm.ordersData[0].rate)) +
                                      "%\n            "
                                  )
                                ])
                              : _c("div", { staticClass: "text-orange" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-down",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(Math.abs(_vm.ordersData[0].rate)) +
                                      "%\n            "
                                  )
                                ]),
                            _vm._v(" "),
                            _c("table-sales-growth", {
                              attrs: {
                                columns: _vm.ordersColumns,
                                data: _vm.ordersData.slice(1)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mr-t-10" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      _vm.handleClickViewAnalysis()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                さらに表示する\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-circle-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _vm.salesData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "card-content text-right" },
                          [
                            _c("div", {}, [
                              _c("span", { staticClass: "text-size-28" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(_vm.salesData[0].value)
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.salesData[0].unit) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.salesData[0].rate >= 0
                              ? _c("div", { staticClass: "text-green" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-up",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(Math.abs(_vm.salesData[0].rate)) +
                                      "%\n            "
                                  )
                                ])
                              : _c("div", { staticClass: "text-orange" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-down",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(Math.abs(_vm.salesData[0].rate)) +
                                      "%\n            "
                                  )
                                ]),
                            _vm._v(" "),
                            _c("table-sales-growth", {
                              attrs: {
                                columns: _vm.salesColumns,
                                data: _vm.salesData.slice(1)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mr-t-10" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      _vm.handleClickViewAnalysis()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                さらに表示する\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-circle-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-3 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(3),
                    _vm._v(" "),
                    _vm.returnsData.length > 0
                      ? _c(
                          "div",
                          { staticClass: "card-content text-right" },
                          [
                            _c("div", {}, [
                              _c("span", { staticClass: "text-size-28" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatNumber(_vm.returnsData[0].value)
                                  )
                                )
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.returnsData[0].unit) +
                                  "\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _vm.returnsData[0].rate >= 0
                              ? _c("div", { staticClass: "text-green" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-up",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.abs(_vm.returnsData[0].rate)
                                      ) +
                                      "%\n            "
                                  )
                                ])
                              : _c("div", { staticClass: "text-orange" }, [
                                  _c("i", {
                                    staticClass: "fa fa-long-arrow-down",
                                    attrs: { "aria-hidden": "true" }
                                  }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        Math.abs(_vm.returnsData[0].rate)
                                      ) +
                                      "%\n            "
                                  )
                                ]),
                            _vm._v(" "),
                            _c("table-sales-growth", {
                              attrs: {
                                columns: _vm.returnsColumns,
                                data: _vm.returnsData.slice(1)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "mr-t-10" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary",
                                  on: {
                                    click: function($event) {
                                      _vm.handleClickViewAnalysis()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                さらに表示する\n                "
                                  ),
                                  _c("i", {
                                    staticClass: "fa fa-chevron-circle-right",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]
                              )
                            ])
                          ],
                          1
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "row font-bold",
                attrs: { id: "warehouse-status" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _vm._m(4),
                      _vm._v(" "),
                      _vm.warehousesData
                        ? _c(
                            "div",
                            { staticClass: "card-content salemonster-info" },
                            [
                              _c("div", { staticClass: "usage-plan" }, [
                                _c("span", [_vm._v("ご利用プラン")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-size-32 text-right",
                                    class: {
                                      "plan-basic-text": _vm.isBasicPlan,
                                      "plan-premium-text": !_vm.isBasicPlan
                                    }
                                  },
                                  [
                                    _c("span", [_vm._v(_vm._s(_vm.plan))]),
                                    _vm._v(" "),
                                    _vm.isPremiumTrial
                                      ? _c(
                                          "span",
                                          { staticClass: "text-size-20" },
                                          [_vm._v("(トライアル)")]
                                        )
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _vm.isBasicPlan || _vm.isPremiumTrial
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: {
                                            click: function($event) {
                                              _vm.handleClickJoinPremium()
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  プレミアム登録はコチラ\n                  "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-chevron-circle-right",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "items-available-sale" },
                                [
                                  _c("span", [_vm._v("出品可能数")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-10",
                                      staticStyle: {
                                        flex: "1",
                                        "justify-content": "right",
                                        "align-items": "baseline"
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v("残り")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-green" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text-size-28" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.warehousesData.available
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", {}, [_vm._v("件")])
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        on: {
                                          click: function($event) {
                                            _vm.handleClickAddAvailableQuantity()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  出品可能数を追加する\n                  "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-chevron-circle-right",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "review-status" }, [
                                _c("span", [_vm._v("審査状況")]),
                                _vm._v(" "),
                                _c("div", { staticStyle: { flex: "1" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-10",
                                      staticStyle: {
                                        "justify-content": "right",
                                        "align-items": "baseline"
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v("審査中")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-green" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text-size-28" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.warehousesData.review
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    件\n                  "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-10",
                                      staticStyle: {
                                        "justify-content": "right",
                                        "align-items": "baseline"
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v("出品中")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-green" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text-size-28" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.warehousesData.sale
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    件\n                  "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex gap-10",
                                      staticStyle: {
                                        "justify-content": "right",
                                        "align-items": "baseline"
                                      }
                                    },
                                    [
                                      _c("span", [_vm._v("審査NG")]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-red" }, [
                                        _c(
                                          "span",
                                          { staticClass: "text-size-28" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.warehousesData.reject
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    件\n                  "
                                        )
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      on: {
                                        click: function($event) {
                                          _vm.handleClickRequestReconsideration()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  再審査を依頼する\n                  "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "fa fa-chevron-circle-right",
                                        attrs: { "aria-hidden": "true" }
                                      })
                                    ]
                                  )
                                ])
                              ])
                            ]
                          )
                        : _c("div", { staticClass: "text-center" }, [
                            _c("i", { staticClass: "fa fa-spinner fa-spin" })
                          ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-content" }, [
                        _c("div", { staticClass: "selmon-logi" }, [
                          _c("div", { staticClass: "selmon-logi-sc" }, [
                            _c("div", [
                              _c("img", {
                                staticClass: "w-30",
                                attrs: { src: _vm.iconUrls["salmonSc"] }
                              }),
                              _vm._v(" "),
                              _c("span", [_vm._v("STOCKCREW倉庫")])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "selmon-logi-info" }, [
                              _c("span", [_vm._v("ご利用状況")]),
                              _vm._v(" "),
                              _vm.warehouseScUsed
                                ? _c(
                                    "span",
                                    { staticClass: "text-size-28 text-green" },
                                    [_vm._v("利用中")]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "text-size-28 text-red" },
                                    [_vm._v("未利用")]
                                  ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    flex: "1",
                                    "text-align": "right",
                                    "align-self": "center"
                                  }
                                },
                                [
                                  _vm.warehouseScUsed
                                    ? _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: {
                                            click: function($event) {
                                              _vm.handleClickOpenWarehouse(
                                                "salmonSc"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      STOCKCREW倉庫を開く\n                      "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-chevron-circle-right",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          on: {
                                            click: function($event) {
                                              _vm.handleClickGetStarted(
                                                "salmonSc"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      利用を開始する\n                      "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa fa-chevron-circle-right",
                                            attrs: { "aria-hidden": "true" }
                                          })
                                        ]
                                      )
                                ]
                              )
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                  },
                  [
                    _c("div", { staticClass: "card" }, [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-content agent-notification-list" },
                        [
                          _vm.userInfo.hasReturnRecommend
                            ? _c(
                                "div",
                                {
                                  staticClass: "agent-notification-item",
                                  on: {
                                    click: function($event) {
                                      _vm.$router.push("/salemon-agent")
                                    }
                                  }
                                },
                                [
                                  _vm._m(7),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "agent-notification-body" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "agent-notification-text"
                                        },
                                        [
                                          _vm._v("FBAで無駄な手数料が"),
                                          _c("br"),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "agent-notification-number"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.userInfo.totalFbaFee
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" 円発生しています！")
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._m(8)
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isBasicPlan || this.isPremiumTrial
                            ? _c("div", [
                                _vm._m(9),
                                _vm._v(" "),
                                _vm._m(10),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "full-width text-right mr-t-10"
                                  },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-primary",
                                        on: {
                                          click: function($event) {
                                            _vm.$router.push(
                                              "/setting/plan-info"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  プレミアム登録はコチラ\n                  "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fa fa-chevron-circle-right",
                                          attrs: { "aria-hidden": "true" }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            : [
                                _vm.userInfo.countFbaProductSales > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "agent-notification-item",
                                        on: {
                                          click: function($event) {
                                            _vm.$router.push(
                                              "/salemon-agent/fba-product-sales"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(11),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "agent-notification-body"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "agent-notification-text"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "agent-notification-number agent-notification-number--green"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumber(
                                                          _vm.userInfo
                                                            .countFbaProductSales
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" 件の商品を納品して、"),
                                                _c("br"),
                                                _vm._v(
                                                  "適切な在庫レベルを維持しよう!"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(12)
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.userInfo.countSelmonProductsAvailable > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "agent-notification-item",
                                        on: {
                                          click: function($event) {
                                            _vm.$router.push(
                                              "/salemon-agent/product-available"
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(13),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "agent-notification-body"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "agent-notification-text"
                                              },
                                              [
                                                _vm._v("商品を "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "agent-notification-number agent-notification-number--blue"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatNumber(
                                                          _vm.userInfo
                                                            .countSelmonProductsAvailable
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" 件出品して、"),
                                                _c("br"),
                                                _vm._v(
                                                  "売上アップにつなげよう！"
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(14)
                                      ]
                                    )
                                  : _vm._e()
                              ]
                        ],
                        2
                      )
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(15),
                    _vm._v(" "),
                    _vm.notices.length > 0
                      ? _c(
                          "div",
                          { staticClass: "card-content text-size-14" },
                          _vm._l(_vm.notices, function(notice, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "border-bottom-dotted flexbox gap-10 hover-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.handleViewNotice(notice)
                                  }
                                }
                              },
                              [
                                _c("span", [_vm._v(_vm._s(notice.date))]),
                                _vm._v(" "),
                                _c("span", [
                                  _c("a", {
                                    attrs: { href: "javascript:void(0)" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.replaceHTMLSellerInfo(notice.title)
                                      )
                                    }
                                  })
                                ])
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(16),
                    _vm._v(" "),
                    _vm.eventData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-flow-column text-size-14 card-content"
                          },
                          _vm._l(_vm.eventData, function(item, index) {
                            return _c(
                              "a",
                              {
                                key: index,
                                staticClass: "border-bottom-dotted",
                                attrs: { href: item.destUrl, target: "_blank" },
                                on: {
                                  click: function($event) {
                                    !item.destUrl && $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.content) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-external-link",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "col-xs-12 col-sm-12 col-md-12 col-lg-4 equal-box"
                },
                [
                  _c("div", { staticClass: "card" }, [
                    _vm._m(17),
                    _vm._v(" "),
                    _vm.manualData
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex flex-flow-column text-size-14 card-content"
                          },
                          _vm._l(_vm.manualData, function(item, index) {
                            return _c(
                              "a",
                              {
                                key: index,
                                staticClass: "border-bottom-dotted",
                                attrs: { href: item.destUrl, target: "_blank" },
                                on: {
                                  click: function($event) {
                                    !item.destUrl && $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.content) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-external-link",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            )
                          }),
                          0
                        )
                      : _c("div", { staticClass: "text-center" }, [
                          _c("i", { staticClass: "fa fa-spinner fa-spin" })
                        ])
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.bottomBanner, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4"
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: item.destUrl, target: "_blank" },
                        on: {
                          click: function($event) {
                            !item.destUrl && $event.preventDefault()
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "full-width",
                          attrs: { src: item.content }
                        })
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _vm.isShowModalAmazonExpiration && _vm.amazonExpirationContext.length
            ? _c("modal-amazon-expiration", {
                attrs: { amazonExpirationContext: _vm.amazonExpirationContext }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", { staticClass: "fa fa-jpy", attrs: { "aria-hidden": "true" } }),
      _vm._v(" 本日の売上金額\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", {
        staticClass: "fa fa-line-chart",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" 本日の注文件数\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", {
        staticClass: "fa fa-shopping-cart",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" 本日の販売個数\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", { staticClass: "fa fa-reply", attrs: { "aria-hidden": "true" } }),
      _vm._v(" 本日の返品個数\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("img", {
        staticClass: "w-30",
        attrs: { src: "/static/dists/img/ic_SaleMonster24.png" }
      }),
      _vm._v("\n            セールモンスター\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("img", {
        staticClass: "w-30",
        attrs: {
          src: "https://image-yoshino.sakura.ne.jp/monster/SaleMonLogi.png"
        }
      }),
      _vm._v("\n            セルモンロジ\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("img", {
        staticClass: "w-30",
        attrs: {
          src: "https://image-yoshino.sakura.ne.jp/monster/SaleMonAgent.png"
        }
      }),
      _vm._v("\n            セルモンエージェント通知\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "agent-notification-icon agent-notification-icon--orange"
      },
      [_c("i", { staticClass: "fa fa-folder-open" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "agent-notification-action agent-notification-action--orange"
      },
      [
        _vm._v("\n                エージェント画面を開く "),
        _c("i", {
          staticClass: "fa fa-chevron-right",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-notification-item" }, [
      _c(
        "div",
        {
          staticClass: "agent-notification-icon agent-notification-icon--green"
        },
        [_c("i", { staticClass: "fa fa-bullhorn" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "agent-notification-body" }, [
        _c("div", { staticClass: "agent-notification-text" }, [
          _vm._v("売れ行きを予測し、適切なFBA納品数をご提案します!")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "agent-notification-item" }, [
      _c(
        "div",
        {
          staticClass: "agent-notification-icon agent-notification-icon--blue"
        },
        [_c("i", { staticClass: "fa fa-line-chart" })]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "agent-notification-body" }, [
        _c("div", { staticClass: "agent-notification-text" }, [
          _vm._v("売上アップにつながる商品をお知らせ "),
          _c("i", {
            staticClass: "fa fa-envelope-o",
            attrs: { "aria-hidden": "true" }
          }),
          _vm._v(" ワンクリックで出品！")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "agent-notification-icon agent-notification-icon--green" },
      [_c("i", { staticClass: "fa fa-bullhorn" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "agent-notification-action agent-notification-action--green"
      },
      [
        _vm._v("\n                  エージェント画面を開く "),
        _c("i", {
          staticClass: "fa fa-chevron-right",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "agent-notification-icon agent-notification-icon--blue" },
      [_c("i", { staticClass: "fa fa-line-chart" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "agent-notification-action agent-notification-action--blue"
      },
      [
        _vm._v("\n                  エージェント画面を開く "),
        _c("i", {
          staticClass: "fa fa-chevron-right",
          attrs: { "aria-hidden": "true" }
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", {
        staticClass: "fa fa-bullhorn",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" お知らせ\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", {
        staticClass: "fa fa-calendar-o",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(" イベント情報\n          ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("i", { staticClass: "fa fa-book", attrs: { "aria-hidden": "true" } }),
      _vm._v(" マニュアル\n          ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb8a7244", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb8a7244","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/home/Home.vue
// module id = null
// module chunks = 